import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/_services/alert.service';
import { UserDashboardService } from '../user-dashboard.service';
import { PiiFormService } from 'src/app/_services/pii-form.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MenusService } from 'src/app/_services/menu.service';
import { ColDef, GridApi, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerService } from '../../customers/customer-service';
import { CustomerSearchRequest } from '../user-dashboard.service';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from '../../product-management/product-service';
import { DocumentViewerModalComponent } from 'src/app/common/document-viewer-modal.component';
const { defaultCountryCode, defaultCurrency, defaultPageSizeArr, defaultPageSize } = environment;

const MIME_BY_EXT: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrls: ['./customer-dashboard.component.scss']
})
export class CustomerDashboardComponent implements OnInit {
  uuid : any;
  searchEmailId: string;
  searchWalletId: string;
  searchMobileNumber: string;
  searchCineId: string;

  personalDetails: any = {
    governmentId: '',
    userId: '',
    registeredMobileNumber: '',
    passportNumber: '',
    fullName: '',
    email: '',
    expiryDate: '',
    nationality: '',
    dateOfBirth: '',
    gender: '',
    passportExpiryDate: '',
    occupation: '',
    placeOfBirth: '',
    sourceOfFund: '',
    status: ''
  };
  addressFormatted: string;

  deviceDetails: any = {};

  walletDetails: any = {};

  beneficiaryDetails: any[] = [];
  allBeneficiaryDetails: any[] = [];
  filteredBeneficiaryDetails: any[] = [];

  selectedTab: number = 0;

  displayDetails: boolean = false;

  isOperationsUser: boolean = false;

  public permissions: string = '';

  // Beneficiary filter properties
  beneficiaryFilterType: 'all' | 'domestic' | 'international' = 'all';
  beneficiaryFilterCountry: string = '';
  beneficiaryFilterRelation: string = '';
  beneficiaryFilterBankType: string = '';
  beneficiaryFilterShow: boolean = false;
  countryList: any[] = [];
  countryDropDown: any[] = [];
  relationshipDropDown: any[] = [];

  transactionFilterType: 'all' | 'domestic' | 'international' = 'all';
  transactionFilterStatus: string = '';
  transactionFilterTxnId: string = '';
  transactionFilterOriginalTxnId: string = '';
  transactionFilterDateFrom: NgbDateStruct | null = null;
  transactionFilterDateTo: NgbDateStruct | null = null;
  allTransactionDetails: any[] = [];
  filteredTransactionDetails: any[] = [];
  transactionFilterShow: boolean = false;

  public columnDefs: ColDef[] = [
    { field: 'name', headerName: 'Beneficiary Name', lockVisible: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'bankName', headerName: 'Beneficiary Bank', lockVisible: true, },
    { field: 'accountNo', headerName: 'Beneficiary Account No.', lockVisible: true, },
    { field: 'mode', headerName: 'Mode', lockVisible: true, },
    { field: 'bankType', headerName: 'Type', lockVisible: true, },
    { field: 'relation', headerName: 'Relation', lockVisible: true, },
  ]

  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  // for transaction details
  private gridApi!: GridApi;
  currentPage: number = 1;
  pageSize: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: any = 0;
  totalRecords: number = 0;
  transactionDetails: any[] = [];
  transactionColumnDefs: ColDef[] = [
    { field: 'dateTime', sortable: false, lockVisible: true, headerName: 'Trxn Initiated Date' },
    { field: 'updateDateTime', sortable: false, lockVisible: true, headerName: 'Trxn Posted Date' },
    { field: 'merchantIdentifierId', sortable: false, lockVisible: true, headerName: 'Merchant ID' },
    { field: 'walletSenderId', sortable: false, lockVisible: true, headerName: 'Sender Wallet ID' },
    { field: 'senderName', sortable: false, lockVisible: true, headerName: 'Sender Name' },
    { field: 'walletReceiverId', sortable: false, lockVisible: true, headerName: 'Receiver Wallet ID' },
    { field: 'receiverName', sortable: false, lockVisible: true, headerName: 'Receiver name' },
    { field: 'receiverType', sortable: false, lockVisible: true, headerName: 'Receiver Type' },
    { field: '', sortable: false, lockVisible: true, headerName: 'Auth Code' },
    // { field: 'typeOfTransaction', sortable: false, lockVisible: true, headerName: 'Transaction Type' },
    { field: 'productCode', sortable: false, lockVisible: true, headerName: 'MoPayment' },
    { field: 'narration', sortable: false, lockVisible: true, headerName: 'Title/Narration' },
    { field: 'txnId', sortable: false, lockVisible: true, headerName: 'Trxn ID' },
    { field: 'merchantReferenceId', sortable: false, lockVisible: true, headerName: 'Order ID' },
    { field: 'serviceProviderTxnId', sortable: false, lockVisible: true, headerName: 'SP Transaction ID' },
    { field: 'status', sortable: false, lockVisible: true, headerName: 'Transaction Status' },
    { field: 'transactionType', sortable: false, lockVisible: true, headerName: 'CR/DR' },
    { field: 'sendingCurrency', sortable: false, lockVisible: true, headerName: 'Sender Currency' },
    { field: 'currency', sortable: false, lockVisible: true, headerName: 'Receiver Currency' },
    { field: 'exchangeRate', sortable: false, lockVisible: true, headerName: 'FX Rate' },
    { field: 'openingBal', sortable: false, lockVisible: true, headerName: 'Opening Balance' },
    { field: 'amount', sortable: false, lockVisible: true, headerName: 'Trxn Amt' },
    { field: 'serviceCharges', sortable: false, lockVisible: true, headerName: 'Service Charges' },
    { field: 'vat', sortable: false, lockVisible: true, headerName: 'VAT AMT' },
    { field: 'totalAmount', sortable: false, lockVisible: true, headerName: 'Net Amount' },
    // { field: '', sortable: false, lockVisible: true, headerName: 'Discounts/Promo code' },
    { field: 'closingBal', sortable: false, lockVisible: true, headerName: 'Closing Balance' },

    { field: 'mode', sortable: false, lockVisible: true, headerName: 'Mode' },
    { field: 'channel', sortable: false, lockVisible: true, headerName: 'Channel' },
    { field: 'category', sortable: false, lockVisible: true, headerName: 'Category' },
    { field: 'responseMessage', sortable: false, lockVisible: true, headerName: 'Shield Message' },
    { field: 'serviceProviderResponseMessage', sortable: false, lockVisible: true, headerName: 'SP Message' }

  ]
  transactionTableSelectedColumn: ColDef[] = [...(this.transactionColumnDefs.filter((col) => !col?.hide))];

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  constructor(
    private alertService: AlertService,
    private userDashboardService: UserDashboardService,
    private location: Location,
    private router: Router,
    private menuService: MenusService,
    private customerService: CustomerService,
    private piiFormService: PiiFormService,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private productService: ProductService,
    private http: HttpClient,
    private modalService: NgbModal,
  ) { }

  async ngOnInit() {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
    this.isOperationsUser = this.permissions.includes("Edit");
    this.fetchCountryList();
  }

  fetchCountryList() {
    this.productService.getCountryDropdown().subscribe((response: any) => {
      console.log(response);
      this.countryDropDown = response.response.data;
    });

    // Fetch relationships
    this.userDashboardService.getRelationships().subscribe((response: any) => {
      console.log('Relationships:', response);
      if (response && response.response && response.response.data && response.response.data.content) {
        this.relationshipDropDown = response.response.data.content;
      }
    });
  }

  async search() {
    this.displayDetails = false;
    // Reset PII masking state when searching for a new customer
    this.piiFormService.maskAllFields();
    // Set tab to Personal Details (tab 0)
    this.selectedTab = 0;
    const contactNumber = this.searchMobileNumber?.trim();
    const governmentId = this.searchCineId?.trim();
    const walletId = this.searchWalletId?.trim();
    if (!contactNumber && !governmentId && !walletId) {
      this.alertService.toastWarringMessageAlertWithMessage("Please enter atleast one field to search");
      return;
    }

    const searchRequest: CustomerSearchRequest = {
      userType: 'CUSTOMER',
      ...(contactNumber ? { contactNumber } : {}),
      ...(governmentId ? { governmentId } : {}),
      ...(walletId ? { walletId } : {}),
    };
    const response: any = await firstValueFrom(this.userDashboardService.searchCustomer(searchRequest));
    const searchResult = response?.response?.status === 200 ? response.response.data : null;

    if (!searchResult?.userId) {
      Swal.fire("User not found", undefined, "error");
    } else {
      this.uuid = searchResult.userId;
      this.searchMobileNumber = searchResult.contactNumber || this.searchMobileNumber;
      this.handleSearchResponse(searchResult.userId);
    }
  }

  handleUserDetailsResponse(resp: any): void {
    if (resp && resp.response && resp.response.data) {
      this.personalDetails = resp.response.data;
      if (this.personalDetails.address) {
        this.addressFormatted = [this.personalDetails.address.apartment, this.personalDetails.address.emirate, this.personalDetails.address.street].filter(Boolean).join(", ")
      }
    }
  }

  // frontImageDocUrl/backImageDocUrl is a generic placeholder; actual CNIE scans live in documentInfos
  viewCnieDocument(documentType: 'CIN_FRONT' | 'CIN_BACK', title: string): void {
    const doc = (this.personalDetails?.documentInfos || []).find((d: any) => d.documentType === documentType);
    const path = doc?.documentPath;
    if (!path) {
      this.alertService.toastWarringMessageAlertWithMessage(`${title} is not available`);
      return;
    }

    this.http
      .get(`${environment.API_URLBLAZE}/user/files/download`, {
        params: { path },
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response) => {
          const serverType = response.headers.get('Content-Type') ?? '';
          const ext = path.split('.').pop()?.toLowerCase() ?? '';
          const contentType =
            serverType && !serverType.toLowerCase().startsWith('application/octet-stream')
              ? serverType
              : MIME_BY_EXT[ext] ?? 'application/pdf';

          const blob = new Blob([response.body as BlobPart], { type: contentType });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const modalRef = this.modalService.open(DocumentViewerModalComponent, {
              size: 'xl',
              centered: true,
            });
            modalRef.componentInstance.dataUrl = reader.result as string;
            modalRef.componentInstance.title = title;
            modalRef.componentInstance.isImage = contentType.startsWith('image/');
            modalRef.componentInstance.contentType = contentType;
          };
        },
        error: () => {
          this.alertService.errorAlert({ html: `Unable to load ${title}. Please try again.` });
        },
      });
  }

  handleDeviceInfoDetailsResponse(resp: any): void {
    if (resp != null && resp.response != null && resp.response.data != null) {
      this.deviceDetails = resp.response.data;
    }
  }

  handleWalletDetailsResponse(resp: any): void {
    if (resp != null && resp.response != null && resp.response.data != null) {
      this.walletDetails = resp.response.data;
    }
  }


  handleBeneficiaryDetailsResponse(resp: any): void {
    if (resp != null && resp.response != null) {
      // Check if status is not 200
      if (resp.response.status !== 200) {
        const errorMessage = resp.response.message || 'An error occurred while fetching beneficiary details';
        Swal.fire('Error', errorMessage, 'error');
        // Clear beneficiary details on error
        this.allBeneficiaryDetails = [];
        this.filteredBeneficiaryDetails = [];
        this.beneficiaryDetails = [];
        return;
      }

      // Handle successful response
      if (resp.response.data != null) {
        this.allBeneficiaryDetails = resp.response.data.map((_: any) => {
          _.mode = _.countryCode == defaultCountryCode ? "Domestic" : "International";
          return _;
        });
        this.applyBeneficiaryFilters();
      }
    }
  }

  handleSearchResponse(userId: string) {
    this.displayDetails = true;
    this.userDashboardService.getUserDetails(userId, "CUSTOMER", this.searchMobileNumber).subscribe((resp) => {
      this.handleUserDetailsResponse(resp);
    });

    this.userDashboardService.getDeviceInfoDetails(userId).subscribe((resp) => {
      this.handleDeviceInfoDetailsResponse(resp);
    });

    this.userDashboardService.getWalletDetails(userId).subscribe((resp) => {
      this.handleWalletDetailsResponse(resp);
    });

    this.fetchBeneficiaryDetails(userId);
    this.fetchTransactionDetails(userId);
  }

  unfreezeAccount(){
    const status = "ACTIVE";
    const remark = "Unfreezed Account";
    if(this.personalDetails.status == "SUSPENDED"){
      //call api status change
      let walletStatusChangeRequest = {
          "userId" : this.uuid,
          "status" : status,
          "remark" : remark
      }
      this.customerService.updateCustomerWalletStatusChange(walletStatusChangeRequest)
        .subscribe((data:any) => {
          if(data.response.status == 200){
            Swal.fire('Customer wallet status updated successfully','','success')
            this.piiFormService.maskAllFields();
            this.handleSearchResponse(this.uuid);
            return;
          }else{
            Swal.fire(data.response.message,'','error')
            return;
          }
        })
    }
  }

  unmaskAllPiiFields(): void {
    this.piiFormService.unmaskAllFields(this.personalDetails?.userId || 'unknown', 'customer');
  }

  fetchTransactionDetails(userId?: string) {
    console.log("fetchTransactionDetails")
    let productCode: string | undefined;
    if (this.transactionFilterType === 'international') {
      productCode = 'CROSS_BORDER_TRANSFER';
    } else if (this.transactionFilterType === 'domestic') {
      productCode = undefined;
    } else {
      productCode = undefined;
    }

    const filters: any = {};

    if (this.transactionFilterDateFrom || this.transactionFilterDateTo) {
      let createDateFilter = '';
      if (this.transactionFilterDateFrom) {
        const monthStr = this.transactionFilterDateFrom.month < 10 ? `0${this.transactionFilterDateFrom.month}` : `${this.transactionFilterDateFrom.month}`;
        const dayStr = this.transactionFilterDateFrom.day < 10 ? `0${this.transactionFilterDateFrom.day}` : `${this.transactionFilterDateFrom.day}`;
        const fromDateStr = `${this.transactionFilterDateFrom.year}-${monthStr}-${dayStr} 00:00:00`;
        createDateFilter = `gte%3D${encodeURIComponent(fromDateStr)}`;
      }
      if (this.transactionFilterDateTo) {
        const monthStr = this.transactionFilterDateTo.month < 10 ? `0${this.transactionFilterDateTo.month}` : `${this.transactionFilterDateTo.month}`;
        const dayStr = this.transactionFilterDateTo.day < 10 ? `0${this.transactionFilterDateTo.day}` : `${this.transactionFilterDateTo.day}`;
        const toDateStr = `${this.transactionFilterDateTo.year}-${monthStr}-${dayStr} 23:59:59`;
        if (createDateFilter) {
          createDateFilter += `%24lte%3D${encodeURIComponent(toDateStr)}`;
        } else {
          createDateFilter = `lte%3D${encodeURIComponent(toDateStr)}`;
        }
      }
      filters.createDate = createDateFilter;
    }

    if (this.transactionFilterTxnId && this.transactionFilterTxnId.trim() !== '') {
      filters.txnId = this.transactionFilterTxnId.trim();
    }

    if (this.transactionFilterOriginalTxnId && this.transactionFilterOriginalTxnId.trim() !== '') {
      filters.originalTxnId = this.transactionFilterOriginalTxnId.trim();
    }

    if (this.transactionFilterStatus && this.transactionFilterStatus.trim() !== '') {
      filters.status = this.transactionFilterStatus.trim();
    }
    if (this.transactionFilterType === 'domestic') {
      filters.productCode = `ne%3D${encodeURIComponent('CROSS_BORDER_TRANSFER')}`;
    }

    this.userDashboardService.getTransactionReportListForCustomer(userId??this.uuid, this.pageSize, this.pageNumber, productCode, filters)
    .subscribe((resp: any) => {
      if (resp?.response?.status === 200) {
        this.allTransactionDetails = resp.response.data.content.map((_: any) => {
          _.sendingCurrency = defaultCurrency;
          _.serviceCharges ??= 0;
          _.vat ??= 0;
          _.openingBal ??= 'NA';
          _.closingBal ??= 'NA';
          _.isInternational = _.receiverCountry && _.receiverCountry !== defaultCountryCode ||
                              (_.currency && _.currency !== defaultCurrency && _.currency !== _.sendingCurrency);
          return _;
        });
        this.totalRecords = resp.response.data.totalElements;
        this.transactionDetails = this.allTransactionDetails;
        if (this.gridApi) {
          this.gridApi.setRowData(this.transactionDetails);
        }
      }
    })
  }

  onTransactionGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.paginationSetPageSize(this.pageSize);
  }

  onPageSizeChanges($event: Event) {
    console.log("onPageSizeChanges: " + this.pageSize)
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.transactionDetails })
    this.gridApi.showLoadingOverlay();
    this.pageNumber = 0;
    this.currentPage = 1;
    this.fetchTransactionDetails(this.uuid);
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    console.log("onPaginationChange: " + param);
    this.gridApi.applyTransaction({ remove: this.transactionDetails })
    this.gridApi.showLoadingOverlay();
    this.pageNumber = (param - 1)
    this.currentPage = param;
    this.fetchTransactionDetails(this.uuid);
  }

  onTransactionFilterTypeChange(type: 'all' | 'domestic' | 'international') {
    this.transactionFilterType = type;
    this.pageNumber = 0;
    this.currentPage = 1;
    this.fetchTransactionDetails(this.uuid);
  }

  applyTransactionFilters() {
    this.pageNumber = 0;
    this.currentPage = 1;
    this.fetchTransactionDetails(this.uuid);
  }

  resetTransactionFilters() {
    this.transactionFilterType = 'all';
    this.transactionFilterStatus = '';
    this.transactionFilterTxnId = '';
    this.transactionFilterOriginalTxnId = '';
    this.transactionFilterDateFrom = null;
    this.transactionFilterDateTo = null;
    this.pageNumber = 0;
    this.currentPage = 1;
    this.fetchTransactionDetails(this.uuid);
  }

  onBeneficiaryFilterTypeChange(type: 'all' | 'domestic' | 'international') {
    this.beneficiaryFilterType = type;
    this.fetchBeneficiaryDetails(this.uuid);
  }

  fetchBeneficiaryDetails(userId: string) {
    let internationalParam: boolean | undefined;
    if (this.beneficiaryFilterType === 'domestic') {
      internationalParam = false;
    } else if (this.beneficiaryFilterType === 'international') {
      internationalParam = true;
    } else {
      internationalParam = undefined;
    }

    this.userDashboardService.getBeneficiaryDetails(userId, internationalParam).subscribe((resp) => {
      this.handleBeneficiaryDetailsResponse(resp);
    });
  }

  applyBeneficiaryFilters() {
    let filtered = [...this.allBeneficiaryDetails];
    if (this.beneficiaryFilterCountry && this.beneficiaryFilterCountry.trim() !== '') {
      filtered = filtered.filter(b =>
        b.countryCode?.toUpperCase() === this.beneficiaryFilterCountry.toUpperCase() ||
        b.countryName?.toLowerCase().includes(this.beneficiaryFilterCountry.toLowerCase())
      );
    }
    if (this.beneficiaryFilterRelation && this.beneficiaryFilterRelation.trim() !== '') {
      filtered = filtered.filter(b =>
        b.relation?.toLowerCase().includes(this.beneficiaryFilterRelation.toLowerCase())
      );
    }
    if (this.beneficiaryFilterBankType && this.beneficiaryFilterBankType.trim() !== '') {
      filtered = filtered.filter(b =>
        b.bankType?.toLowerCase().includes(this.beneficiaryFilterBankType.toLowerCase()) ||
        (this.beneficiaryFilterBankType.toLowerCase() === 'upi' && b.upiId) ||
        (this.beneficiaryFilterBankType.toLowerCase() === 'bank' && !b.upiId)
      );
    }

    this.filteredBeneficiaryDetails = filtered;
    this.beneficiaryDetails = filtered;
  }

  resetBeneficiaryFilters() {
    this.beneficiaryFilterType = 'all';
    this.beneficiaryFilterCountry = '';
    this.beneficiaryFilterRelation = '';
    this.beneficiaryFilterBankType = '';
    this.fetchBeneficiaryDetails(this.uuid);
  }

  toggleTransactionFilter() {
    this.transactionFilterShow = !this.transactionFilterShow;
  }

  toggleBeneficiaryFilter() {
    this.beneficiaryFilterShow = !this.beneficiaryFilterShow;
  }
}
